const RefillRequests = () => {
  return <div>RefillRequests</div>;
};

export default RefillRequests;
